import Node from '../node.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';
import Utils3D from '../../utils/utils3D.js';

export default class NodeArrayGeometry extends Node
{
	constructor(pParent)
	{
		super(pParent);
		
		this.addInput(PARAM_TYPE.GEOMETRY, 'geo', null);
		this.addInput(PARAM_TYPE.GEOMETRY, 'alignObject', null);

		this.addInput(PARAM_TYPE.INTEGER, 'x count', 1, { minValue: 1, maxValue: 15 });
		this.addInput(PARAM_TYPE.FLOAT, 'x spacing', 0.2, { units: PARAM_UNITS.METERS });

		this.addInput(PARAM_TYPE.INTEGER, 'y count', 1, { minValue: 1, maxValue: 15 });
		this.addInput(PARAM_TYPE.FLOAT, 'y spacing', 0.2, { units: PARAM_UNITS.METERS });

		this.addInput(PARAM_TYPE.INTEGER, 'z count', 1, { minValue: 1, maxValue: 15 });
		this.addInput(PARAM_TYPE.FLOAT, 'z spacing', 0.2, { units: PARAM_UNITS.METERS });

		this.addInput(PARAM_TYPE.BOOLEAN, 'use_instances', false);
		
		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');	
	}
	
	getType()
	{
		return 'array';
	}
	
	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{		
		let pGeoList = inputValues['geo'];
		if(!pGeoList)
			return null;
		
		// Determine the coordinate system
		let pAlignMesh;
		let vecAxes = [];
		if(inputValues['alignObject'] && inputValues['alignObject'].length > 0 && inputValues['alignObject'][0])
		{
			// We have an object to align to
			pAlignMesh = inputValues['alignObject'][0];
			pAlignMesh.computeWorldMatrix(true);

			let worldMatrix = pAlignMesh.getWorldMatrix();
			for(let rowIndex = 0; rowIndex < 3; rowIndex++)
			{
				let matrixRow = worldMatrix.getRow(rowIndex);
				vecAxes[rowIndex] = new BABYLON.Vector3(matrixRow.x, matrixRow.y, matrixRow.z);
				vecAxes[rowIndex].normalize();
			}
		}
		else
		{
			// Use world coordinate system
			vecAxes[0] = new BABYLON.Vector3(1, 0, 0);
			vecAxes[1] = new BABYLON.Vector3(0, 1, 0);
			vecAxes[2] = new BABYLON.Vector3(0, 0, 1);
		}

		let pNewMeshes = [];

		let instanceMeshMap = {};

		let bbox = Utils3D.getObjectsBBox(pGeoList);
		let vecSize = bbox.maximumWorld.subtract(bbox.minimumWorld);
		let iCounter = 0;
		let pNewMesh;
		for(let iXIndex = 0; iXIndex < inputValues['x count']; iXIndex++)
		{
			for(let iYIndex = 0; iYIndex < inputValues['y count']; iYIndex++)
			{
				for(let iZIndex = 0; iZIndex < inputValues['z count']; iZIndex++)
				{
					for(let pSrcMesh of pGeoList)
					{
						let bCreateInstance = !!(inputValues['use_instances'] && instanceMeshMap[pSrcMesh.uniqueId]);
						let trueSourceMesh = bCreateInstance ? instanceMeshMap[pSrcMesh.uniqueId] : pSrcMesh;

						pNewMesh = Utils3D.cloneMesh(trueSourceMesh, this.getGeneratedMeshName() + "_" + iCounter, true, bCreateInstance);
						if(inputValues['use_instances'] && !instanceMeshMap[pSrcMesh.uniqueId])
							instanceMeshMap[pSrcMesh.uniqueId] = pNewMesh;

						this.onMeshCreated(pNewMesh);
						iCounter++;

						pNewMesh.position = trueSourceMesh.position.add(vecAxes[0].scale((vecSize.x + inputValues['x spacing'])*iXIndex));
						pNewMesh.position = pNewMesh.position.add(vecAxes[1].scale((vecSize.y + inputValues['y spacing'])*iYIndex));
						pNewMesh.position = pNewMesh.position.add(vecAxes[2].scale((vecSize.z + inputValues['z spacing'])*iZIndex));

						if(pAlignMesh)
							pNewMesh.rotation = pAlignMesh.rotation.clone();

						pNewMeshes.push(pNewMesh);
					}
				}
			}
		}

		// Dispose of the originals
		for(let pSrcMesh of pGeoList)
			pSrcMesh.dispose();

		return pNewMeshes;
	}

}